/**
 * @summary - Component that Provides PPM Planner Repository 
 * @autor vengateshwaran k
 * @since 2024-06-21
 */
import { BemsGraph, FemsGraph,MasterGraph } from "../../utility/apiURLS";
import Axios from '../data-access/genericAxios';
import  ReArrangeLabel  from "../../components/commoncomponents/ReArrangeLabel";


async function getAssetNoDetails(facilityId) {
  const response = await Axios.get(`${FemsGraph}/api/Predictivemaintenance/GetpredictivemaintenanceAssetNoFetch/${facilityId}?size=3000`);
  if(response?.status !== 'error'){
   const reArrangedData=ReArrangeLabel(response?.data,"assetNo","label"); 
   return reArrangedData;
   }
   return response;
}

async function getBemsAssetNoDetails(facilityId) {
    const response = await Axios.get(`${BemsGraph}/api/Predictivemaintenance/GetpredictivemaintenanceAssetNoFetch/${facilityId}?size=3000`);
      if(response?.status !== 'error'){
     const reArrangedData=ReArrangeLabel(response?.data,"assetNo","label"); 
     return reArrangedData;
     }
     return response;
  }

  async function getStaffDetails(facilityId) {  
    const response = await Axios.get(`${BemsGraph}/api/Bemunscheduledworkorder/GetWorkOrderEmployeeDetailsFetchList/${facilityId},1,100`);

    if(response?.status == 200){
     const reArrangedData=ReArrangeLabel(response?.data,"employeename","label"); 
     return reArrangedData;
     }
    // return response;
  }
  async function getBemsStaffDetails(facilityId) {  
    const response = await Axios.get(`${FemsGraph}/api/Bemunscheduledworkorder/GetWorkOrderEmployeeDetailsFetchList/${facilityId}?size=3000`);
 
      if(response?.status !== 'error'){
     const reArrangedData=ReArrangeLabel(response?.data,"employeename","label"); 
     return reArrangedData;
     }
     return response;
  }
  async function getPDMListForMainPage(PredictiveId) {     
    const response = await Axios.get(`${FemsGraph}/api/Predictivemaintenance/PredictiveMaintenanceGetId/${PredictiveId}`);
      return response;
  }
  async function getBemsPDMListForMainPage(PredictiveId) {  
    const response = await Axios.get(`${BemsGraph}/api/Predictivemaintenance/PredictiveMaintenanceGetId/${PredictiveId}`);
    return response;
  }

  async function getPDMList(facilityId,filterModel,sortModel,pageIndex,pageSize) {  
    const response = await Axios.get(`${FemsGraph}/api/Predictivemaintenance/GetpredictivemaintenanceList/${facilityId}?page=${pageIndex}&size=${pageSize}&filterOptions=${JSON.stringify(
        filterModel
      )}&sortOptions=${JSON.stringify(sortModel)}`);
      return response;
  }

  async function getPDMListById(id) {  
    const response = await Axios.get(`${FemsGraph}/api/fempredictivemaintenances/${id}`);
      return response;
  }


  async function createPDM(values) {  
    const response = await Axios.post(`${FemsGraph}/api/fempredictivemaintenances`,values);
      return response;
  }

  async function createBemsPDM(values) {  
    const response = await Axios.post(`${BemsGraph}/api/bempredictivemaintenances`,values);
      return response;
  }
  
  async function updatePDM(values,id) {  
    const response = await Axios.update(`${FemsGraph}/api/fempredictivemaintenances/${id}`,values);
      return response;
  }

  async function updateBemsPDM(values,id) {  
    const response = await Axios.update(`${BemsGraph}/api/bempredictivemaintenances/${id}`,values);
      return response;
  }



  async function getBemsPDMList(facilityId,filterModel,sortModel,pageIndex,pageSize) {  
    const response = await Axios.get(`${BemsGraph}/api/Predictivemaintenance/GetpredictivemaintenanceList/${facilityId}?page=${pageIndex}&size=${pageSize}&filterOptions=${JSON.stringify(
        filterModel
      )}&sortOptions=${JSON.stringify(sortModel)}`);
      return response;
  }
  async function getBemsPDMListById(facilityId,id) {  
    const response = await Axios.get(`${BemsGraph}/api/bempredictivemaintenances/${id}`);
      return response;
  }
  
async function addBemsPDMscheduleTracks(values) { 
  const response = await Axios.post(`${BemsGraph}/api/bempredictivemaintenancetracks`,values); 

   return response;
 }
 async function addPDMscheduleTracks(values) { 
  const response = await Axios.post(`${FemsGraph}/api/fempredictivemaintenancetracks`,values);
   return response;
 }


 async function updateAllApprovedBy(id,values) { 
  const response = await Axios.update(`${FemsGraph}/api/Graphppmscheduledetails/${id}`,values); 
   if(response?.status !== 'error'){
 
   }
   return response;
 }
 async function removePdmList(id) { 
  const response = await Axios.remove(`${FemsGraph}/api/fempredictivemaintenances/${id}`); 
   if(response?.status !== 'error'){
 
   }
   return response;
 }
 async function removeBemsPdmList(id) { 
  const response = await Axios.remove(`${BemsGraph}/api/bempredictivemaintenances/${id}`); 
   if(response?.status !== 'error'){
 
   }
   return response;
 }


 async function getTaskCodeDetails(facilityId,workGroupId) {
  const response = await Axios.get(`${FemsGraph}/api/Graphppmscheduledetails/GetFemPPMScheduleDetailsTaskCodeFetch/${facilityId},${workGroupId}?size=10000`); 
  if(response?.status !== 'error'){
  const reArrangedData=ReArrangeLabel(response?.data,"taskcode","label"); 
  return reArrangedData;
  }
  return response;
}
async function getBemsTaskCodeDetails(facilityId,workGroupId) {
  const response = await Axios.get(`${BemsGraph}/api/Graphppmscheduledetails/GetBemPPMScheduleDetailsTaskCodeFetch/${facilityId},${workGroupId}?size=10000`); 
  if(response?.status !== 'error'){
  const reArrangedData=ReArrangeLabel(response?.data,"taskcode","label"); 
  return reArrangedData;
  }
  return response;
}

async function getPDMShowSchedule(predictivemaintenanceId) { 
  const response = await Axios.get(`${FemsGraph}/api/Predictivemaintenance/GetpredictivemaintenancetrackList/${predictivemaintenanceId}?size=1000`); 
  return response;
  }
  async function getBemsPDMShowSchedule(predictivemaintenanceId) { 
    const response = await Axios.get(`${BemsGraph}/api/Predictivemaintenance/GetpredictivemaintenancetrackList/${predictivemaintenanceId}?size=1000`); 
      return response;
    }
    async function removePdmScheduleTracks(id) { 
      // const response = await Axios.remove(`${FemsGraph}/api/fempredictivemaintenancetracks/${id}`); 
      const response = await Axios.remove(`${FemsGraph}/api/fempredictivemaintenancetracks/GetFemPdmscheduletrack/${id}`); 
       return response;
     }
     async function removeBemsPdmScheduleTracks(id) { 
      // const response = await Axios.remove(`${BemsGraph}/api/bempredictivemaintenancetracks/${id}`); 
      const response = await Axios.remove(`${BemsGraph}/api/bempredictivemaintenancetracks/GetBemPdmscheduletrack/${id}`); 
       return response;
     }

     async function updatePDMAssigneorTaskCode(routineInspectionID,staffID,taskCodeID,service) { 
      const checkGraph = service === "FEMS" ? FemsGraph : BemsGraph
      const checkFemorBem = service === "FEMS" ? "fempredictivemaintenancetracks" : "bempredictivemaintenancetracks"
      const response = await Axios.update(`${checkGraph}/api/${checkFemorBem}/UpdateTracktablePdm/${routineInspectionID}/${staffID}/${taskCodeID}` ); 
      return response;
     }


const PremitiveMaintenanceRepository = {
  getAssetNoDetails,
  getBemsAssetNoDetails,
  getStaffDetails,
  getPDMList,
  getBemsPDMList,
  createPDM,
  createBemsPDM,
  removePdmList,
  removeBemsPdmList,
  getTaskCodeDetails,
  getBemsTaskCodeDetails,
  getBemsStaffDetails,
  updateAllApprovedBy,
  addBemsPDMscheduleTracks,
  addPDMscheduleTracks,
  updatePDM,
  updateBemsPDM,
  getPDMShowSchedule,
  getBemsPDMShowSchedule,
  removePdmScheduleTracks,
  removeBemsPdmScheduleTracks,
  getBemsPDMListById,
  getPDMListById,
  getBemsPDMListForMainPage,
  getPDMListForMainPage,
  updatePDMAssigneorTaskCode
    };
    
    
export default PremitiveMaintenanceRepository;
    